// Japanese for every sentence the dashboard shows, keyed by its English
// (lib/i18n.js, decision 0030). Keep each {placeholder} exactly as in the key;
// test/ui/i18n.test.js fails on a missing sentence or a placeholder that does
// not match. Metric names stay in English, as Google's Japanese Lighthouse
// prints them, and so do Lighthouse's own check names and our fix guidance.
//
// Machine-assisted and not yet read by a fluent reviewer: a correction is a
// one-line change here.
export default {
  // ---------------------------------------------------------------- The shell: header, footer, navigation, shared controls
  'Skip to content': '本文へスキップ',
  Dashboards: 'ダッシュボード',
  Customise: 'カスタマイズ',
  'Nothing was measured in this window.': 'この期間は計測されていません。',
  'Could not load this. {message}': '読み込めませんでした。{message}',
  Language: '言語',
  'The Japanese is a machine-assisted translation and has not been fully reviewed yet.':
    '日本語は機械翻訳を補助に作成した訳で、まだ十分な確認を終えていません。',
  Close: '閉じる',
  Noise: 'ノイズ',
  'Scores move about {band} points on their own between checks':
    'スコアは計測のたびに約{band}ポイント自然に変動します',
  'Lighthouse scores wobble about {band} points between identical runs. A change smaller than that is not a real change.':
    'Lighthouse のスコアは、同じ条件で計測しても約{band}ポイント揺れます。それより小さい変化は実際の変化ではありません。',
  'mobile, ±{band}': 'モバイル、±{band}',
  'desktop, ±{band}': 'デスクトップ、±{band}',
  'Those are the two shaded bands on the chart.': 'グラフ上の2本の網掛けの帯がそれにあたります。',
  '≈ same': '≈ 変化なし',
  'Not measured in {against}': '{against}は未計測',
  'Moved {pts} against {against} — inside the ±{noise} a score drifts on its own':
    '{against}から{pts}変化 — スコアが自然に揺れる±{noise}の範囲内です',
  '{pts} higher than {against}, beyond the ±{noise} noise':
    '{against}より{pts}高く、±{noise}のノイズを超えています',
  '{pts} lower than {against}, beyond the ±{noise} noise':
    '{against}より{pts}低く、±{noise}のノイズを超えています',
  '{words}, {range}': '{words}（{range}）',
  'Scores out of 100, ±{noise} run to run': '100点満点、計測ごとに±{noise}',
  '{label}: {weight}% of the score, {detail}': '{label}：スコアの{weight}%、{detail}',
  '{label}: {weight}% of the score': '{label}：スコアの{weight}%',
  '{subject} performance score': '{subject}のパフォーマンススコア',
  '{what}: not measured': '{what}：未計測',
  '{what}: {n} out of 100': '{what}：100点中{n}点',
  ' and ': '・',
  several: '数',
  'Every guest page': 'すべてのゲスト向けページ',
  '{n} guest page': 'ゲスト向けページ{n}種類',
  '{n} guest pages': 'ゲスト向けページ{n}種類',
  'every hotel site in the sample': 'サンプル内のすべてのホテルサイト',
  'each of {n} hotel site': '{n}軒のホテルサイト',
  'each of {n} hotel sites': '{n}軒のホテルサイトそれぞれ',
  '{pages} on {hotels}': '{hotels}の{pages}',
  'What we measure': '計測するもの',
  '{coverage}, served from our own domain so the number is our code alone. Each runs as a phone and as a desktop.':
    '{coverage}を計測します。自社ドメインから配信しているため、数値は自社のコードだけを反映します。それぞれスマートフォンとデスクトップで計測します。',
  'The search results page, where a guest waits for live prices, on every hotel in the sample. Each runs as a phone and as a desktop.':
    'ゲストがリアルタイムの料金を待つ検索結果ページを、サンプル内のすべてのホテルで計測します。それぞれスマートフォンとデスクトップで計測します。',
  'How often': '計測の頻度',
  'Every day, with Google PageSpeed. It is the same public tool anyone can point at any website, including ours.':
    '毎日、Google PageSpeed で計測します。誰でもどのウェブサイトにも使える公開ツールで、自社のサイトにも同じものを使っています。',
  'Our page every day, competitors once a week, with Google PageSpeed. It is the same public tool anyone can point at any website, including ours.':
    '自社のページは毎日、競合は週に一度、Google PageSpeed で計測します。誰でもどのウェブサイトにも使える公開ツールで、自社のサイトにも同じものを使っています。',
  'How the score is made': 'スコアの算出方法',
  '{failed} of {measurements} checks did not finish. They were left out, not counted as zero.':
    '{measurements}回の計測のうち{failed}回が完了しませんでした。ゼロとして数えず、除外しています。',
  'What the colours mean': '色の意味',
  "Lighthouse's own bands: 90 and up is good, 50 to 89 needs improvement, below 50 is poor. Each metric is held to its own bar for its device, because desktop is scored on a much stricter curve than mobile.":
    'Lighthouse 自身の区分です。90以上は良好、50〜89は改善が必要、50未満は不良です。デスクトップはモバイルよりはるかに厳しい基準で採点されるため、各指標はデバイスごとの基準で判定します。',
  'Why the comparison is fair': '比較が公平である理由',
  'Only pages that run a live search for real prices and real rooms, as ours does, are compared with it. Any other kind of page is labelled on its card and kept out of the comparison.':
    '自社のページと同じく、実際の料金と客室をリアルタイムに検索するページだけを比較対象にしています。それ以外の種類のページはカードにその旨を表示し、比較から外しています。',
  'Powered by {link}': '{link} で計測',
  'Each page is checked {samples} times and we keep the middle result. A score drifts about {band} points on its own, so treat a smaller gap as no gap.':
    '各ページを{samples}回計測し、中央の結果を採用します。スコアはそれだけで約{band}ポイント揺れるため、それより小さい差は差がないものとみなしてください。',
  'Last updated {when}': '最終更新 {when}',
  'Loading…': '読み込み中…',
  'Checked {when}': '{when}にチェック',
  'Check again': '再チェック',
  'New numbers just came in': '新しい数値が届きました',
  'The latest check did not finish.': '最新の計測が完了しませんでした。',
  'These are the last results that did, from {shown}.':
    '表示しているのは、最後に完了した計測（{shown}）の結果です。',
  'These are the last results that did.': '表示しているのは、最後に完了した計測の結果です。',
  Saved: '保存しました',
  'Could not save. This browser is blocking site data.':
    '保存できませんでした。このブラウザはサイトデータをブロックしています。',
  'Mobile line': 'モバイルの線',
  'Desktop line': 'デスクトップの線',
  'Hotel {n}': 'ホテル {n}',
  System: 'システム',
  Light: 'ライト',
  Dark: 'ダーク',
  Appearance: '表示',
  'A preference, not a fact about the data.': '見た目の好みであり、データには影響しません。',
  'Highlight colour': '強調色',
  'Buttons and highlights': 'ボタンと強調表示',
  'This one is used for text as well as fills, so it is held to the stricter of the two.':
    'この色は塗りだけでなく文字にも使うため、より厳しい基準で判定します。',
  'Chart lines': 'グラフの線',
  'A line only has to stand out from the card behind it, not be readable as text.':
    '線は背景のカードから見分けられれば十分で、文字ほどの読みやすさは必要ありません。',
  'Hotel colours': 'ホテルの色',
  'Handed out in this order to the hotels in each customization chart, so the same hotel keeps its colour from one chart to the next.':
    '各カスタマイズのグラフで、この順にホテルへ割り当てます。同じホテルはどのグラフでも同じ色になります。',
  'this device only': 'この端末だけ',
  'Reset to defaults': '初期設定に戻す',
  Done: '完了',
  'Everything here is saved on {where}. It changes how the dashboard looks for you, never the measurements, and never what anyone else sees.':
    'ここでの設定はすべて{where}に保存されます。変わるのはあなたが見るダッシュボードの見た目だけで、計測結果や他の人の画面は変わりません。',
  'the server sent something that was not JSON': 'サーバーから JSON 以外の応答がありました',
  'just now': 'たった今',
  '{n} minutes ago': '{n}分前',
  '1 hour ago': '1時間前',
  '{n} hours ago': '{n}時間前',
  '{n} days ago': '{n}日前',
  'Easy to read': '読みやすい',
  'Contrast {ratio}:1 against the page behind it. Clears the {need}:1 this needs to be easy to read.':
    '背景に対するコントラストは{ratio}:1です。読みやすさに必要な{need}:1を満たしています。',
  'Hard to read': '読みにくい',
  'Contrast {ratio}:1 against the page behind it. Below the {need}:1 this needs to be easy to read.':
    '背景に対するコントラストは{ratio}:1です。読みやすさに必要な{need}:1を下回っています。',
  'Easy to see': '見やすい',
  'Contrast {ratio}:1 against the page behind it. Clears the {need}:1 this needs to be easy to see.':
    '背景に対するコントラストは{ratio}:1です。見やすさに必要な{need}:1を満たしています。',
  'Hard to see': '見にくい',
  'Contrast {ratio}:1 against the page behind it. Below the {need}:1 this needs to be easy to see.':
    '背景に対するコントラストは{ratio}:1です。見やすさに必要な{need}:1を下回っています。',
  Good: '良好',
  'Needs improvement': '改善が必要',
  'below 50': '50未満',
  '50 to 89': '50〜89',
  '90 and up': '90以上',
  'about the same': 'ほぼ同じ',
  '{n} point faster': '{n}ポイント速い',
  '{n} points faster': '{n}ポイント速い',
  '{n} point slower': '{n}ポイント遅い',
  '{n} points slower': '{n}ポイント遅い',
  'too close to call': '差はほぼなし',
  '{n} point ahead': '{n}ポイント上回る',
  '{n} points ahead': '{n}ポイント上回る',
  '{n} point behind': '{n}ポイント下回る',
  '{n} points behind': '{n}ポイント下回る',
  Overview: '概要',
  'Progress over time': '推移',
  Progress: '推移',
  // ---------------------------------------------------------------- Overview
  'The numbers did not load, so there is nothing to export.':
    '数値が読み込まれていないため、書き出すものがありません。',
  'Still loading the numbers.': '数値を読み込み中です。',
  'Still drawing the cards.': 'カードを表示中です。',
  'The other websites are being checked again. Export when it finishes.':
    '他のサイトを再チェック中です。完了してから書き出してください。',
  'Opens the print dialog: choose Save as PDF.':
    '印刷ダイアログが開きます。「PDF として保存」を選んでください。',
  'Tripla Booking Widget · search results page': 'Tripla Booking Widget · 検索結果ページ',
  'measured {when}': '計測 {when}',
  'exported {when}': '書き出し {when}',
  'Demonstration data. These numbers are invented, not measured.':
    'デモ用のデータです。これらの数値は計測値ではなく、架空のものです。',
  'Each page is checked {samples} times and the middle result is kept. A score drifts about ±{band} points on its own, so a smaller gap is no gap.':
    '各ページを{samples}回計測し、中央の結果を採用します。スコアはそれだけで約±{band}ポイント揺れるため、それより小さい差は差とみなしません。',
  'Each page is checked several times and the middle result is kept. A score drifts about ±{band} points on its own, so a smaller gap is no gap.':
    '各ページを複数回計測し、中央の結果を採用します。スコアはそれだけで約±{band}ポイント揺れるため、それより小さい差は差とみなしません。',
  'The latest check, at {at}, did not finish. These are the last results that did, from {measured}.':
    '最新の計測（{at}）は完了しませんでした。表示しているのは、最後に完了した計測（{measured}）の結果です。',
  'The latest check, at {at}, did not finish. These are the last results that did.':
    '最新の計測（{at}）は完了しませんでした。表示しているのは、最後に完了した計測の結果です。',
  'The other websites were checked {from}.': '他のサイトは{from}に計測しました。',
  'The other websites were checked between {from} and {to}.':
    '他のサイトは{from}から{to}の間に計測しました。',
  'Measured with Google PageSpeed, the same public tool anyone can point at any website.':
    'Google PageSpeed で計測しています。誰でもどのウェブサイトにも使える公開ツールです。',
  'Live search': 'リアルタイム検索',
  'Cached search · not compared': 'キャッシュ検索 · 比較対象外',
  OTA: 'OTA',
  'Product page · not compared': '商品ページ · 比較対象外',
  'Unknown page type · not compared': 'ページ種別不明 · 比較対象外',
  'Checks live prices and rooms. Compared with us.':
    'リアルタイムの料金と客室を確認します。比較対象です。',
  'Cached search': 'キャッシュ検索',
  'Shows saved prices, not live ones. Not compared.':
    'リアルタイムではなく保存済みの料金を表示します。比較対象外です。',
  'An online travel agency, measured at its home page.':
    'オンライン旅行予約サイト（OTA）です。トップページを計測しています。',
  'Product page': '商品ページ',
  'A shop page with nothing to look up. Not compared.':
    '検索するものがないショップページです。比較対象外です。',
  'Unknown page type': 'ページ種別不明',
  'We haven’t checked what this page does yet. Not compared.':
    'このページの種類はまだ確認していません。比較対象外です。',
  'Demo hotel': 'デモホテル',
  'The company’s demo hotel, not a real customer. Lighter, so it may score higher.':
    '実際の顧客ではなく、その会社のデモホテルです。軽いため、スコアが高めに出ることがあります。',
  'Not measured yet': '未計測',
  'Waiting for its first check.': '最初の計測を待っています。',
  'No page we can measure fairly': '公平に計測できるページなし',
  'No public page gives a fair comparison.': '公平な比較ができる公開ページがありません。',
  'Checking now': '計測中',
  'Checking now, {done} of {total}': '計測中 {done}/{total}',
  'The other websites were checked again: all {n} checks finished.':
    '他のサイトを再チェックしました。{n}回の計測がすべて完了しました。',
  'The other websites were checked again: {bad} of {n} checks did not finish, and were left out rather than counted as zero.':
    '他のサイトを再チェックしました。{n}回中{bad}回の計測が完了せず、ゼロとして数えずに除外しました。',
  'Check the other websites again: {sites} sites, {checks} checks':
    '他のサイトを再チェック：{sites}サイト、{checks}回の計測',
  'Export PDF': 'PDF を書き出す',
  'Checking the other websites now. {done} of {total} checks done. Our own score is measured every day and is already up to date.':
    '他のサイトを計測中です（{total}回中{done}回完了）。自社のスコアは毎日計測しており、すでに最新です。',
  'We could not load the measurements. Please try again later.':
    '計測結果を読み込めませんでした。しばらくしてからもう一度お試しください。',
  'None of our checks has finished yet, so there is no score to show.':
    'まだ完了した計測がないため、表示できるスコアがありません。',
  'compared with the fastest booking page in this comparison':
    '比較対象の中で最も速い予約ページとの差',
  'How everyone else scores': '他社のスコア',
  'What the words on the cards mean': 'カードの表記の意味',
  'Drag the cards to reorder them. Your order is saved on this device.':
    'カードをドラッグして並べ替えます。並び順はこの端末に保存されます。',
  Reset: 'リセット',
  'demo hotel': 'デモホテル',
  'No page we can measure fairly.': '公平に計測できるページがありません。',
  hold: '長押し',
  'We could not load the other booking pages. Please try again later.':
    '他社の予約ページを読み込めませんでした。しばらくしてからもう一度お試しください。',
  'Loading the other booking pages…': '他社の予約ページを読み込み中…',
  'No competitor has been measured yet, so no comparison is shown.':
    'まだ計測済みの競合がないため、比較は表示されません。',
  'Hold a card to rearrange the grid.': 'カードを長押しすると並べ替えられます。',
  'About these numbers': 'この数値について',
  'Higher is better.': '高いほど良好です。',
  Slow: '遅い',
  Average: '普通',
  Fast: '速い',
  // ---------------------------------------------------------------- Progress
  'checks failed': '計測失敗',
  'Click to see why in Diagnostics ›': 'クリックで診断ページで原因を見る ›',
  'The trend did not load, so there is nothing to export.':
    '推移が読み込まれていないため、書き出すものがありません。',
  'Still loading the trend.': '推移を読み込み中です。',
  'No day in this range has a score.': 'この範囲にスコアのある日はありません。',
  'Saves this chart as a PNG image.': 'このグラフを PNG 画像として保存します。',
  '{device}: {from} → {to}, {move} {over}': '{device}：{from} → {to}、{over}{move}',
  '{device}: {to}, one measured day, nothing to compare it with':
    '{device}：{to}、計測は1日のみで比較対象なし',
  '{device}: no check finished in this range': '{device}：この範囲で完了した計測なし',
  '{device}: nothing measured in this range': '{device}：この範囲の計測なし',
  'A score moves about ±{noise} points between identical checks; the shaded band around each line shows it.':
    '同じ条件の計測でもスコアは約±{noise}ポイント揺れます。各線の周りの網掛けがその幅です。',
  'A score moves about ±{noise} points between identical checks. This style draws no band, so treat a smaller change as no change.':
    '同じ条件の計測でもスコアは約±{noise}ポイント揺れます。この表示では幅を描かないため、それより小さい変化は変化なしとみなしてください。',
  'Median across the hotels in the sample': 'サンプル内のホテルの中央値',
  'current Booking Widget': '現行の Booking Widget',
  'latest good check {when}': '最新の成功した計測 {when}',
  'Search results page: speed over time': '検索結果ページ：速度の推移',
  '▼ marks a day a device fell by more than the noise. ▲ on the floor marks a day whose checks all failed: left out, never counted as zero.':
    '▼はデバイスのスコアがノイズを超えて下がった日です。下端の▲は計測がすべて失敗した日で、ゼロとして数えずに除外しています。',
  'The image could not be made.': '画像を作成できませんでした。',
  '1 week': '1週間',
  'over the last week': '過去1週間で',
  '1 month': '1か月',
  'over the last month': '過去1か月で',
  '3 months': '3か月',
  'over the last 3 months': '過去3か月で',
  '6 months': '6か月',
  'over the last 6 months': '過去6か月で',
  '1 year': '1年',
  'over the last year': '過去1年で',
  Bands: '帯',
  Bars: '棒',
  Heatmap: 'ヒートマップ',
  'Every check in this range failed.': 'この範囲の計測はすべて失敗しました。',
  'Nothing was measured in this range.': 'この範囲は計測されていません。',
  'Search results page': '検索結果ページ',
  'How the speed of the page where guests pick a room has moved over time.':
    'ゲストが客室を選ぶページの速度がどう推移してきたか。',
  'Then and now': '以前と現在',
  'We could not load these scores. Please try again later.':
    'スコアを読み込めませんでした。しばらくしてからもう一度お試しください。',
  'Over time': '推移',
  Range: '範囲',
  'one measured day, nothing to compare it with': '計測は1日のみで比較対象なし',
  'no check finished in this range': 'この範囲で完了した計測なし',
  'nothing measured in this range': 'この範囲の計測なし',
  'We could not load the trend. Please try again later.':
    '推移を読み込めませんでした。しばらくしてからもう一度お試しください。',
  'Chart style': 'グラフの種類',
  'Export PNG': 'PNG を書き出す',
  'Speed score over {n} days, mobile and desktop, each inside its measurement band.':
    '{n}日間の速度スコア（モバイルとデスクトップ、それぞれ計測の幅つき）。',
  'Fell beyond the noise band. Click a marked or failed day to see why in Diagnostics':
    'ノイズ幅を超えて低下。印のある日や失敗した日をクリックすると、診断ページで原因を確認できます',
  // ---------------------------------------------------------------- Diagnostics: the page, its controls and the Summary tab
  Pages: 'ページ',
  'No page was measured on this day.': 'この日に計測されたページはありません。',
  Period: '期間',
  'Week number': '週番号',
  Wk: '週',
  'We could not load the calendar. Please try again later.':
    'カレンダーを読み込めませんでした。しばらくしてからもう一度お試しください。',
  Previous: '前へ',
  Next: '次へ',
  'Trying…': '再試行中…',
  'Try again': '再試行',
  'Full report': 'フルレポート',
  'Check failed': '計測失敗',
  Latest: '最新',
  'All pages': 'すべてのページ',
  'Pages: {label}': 'ページ：{label}',
  'Choose pages': 'ページを選択',
  'Search pages': 'ページを検索',
  'At least one page stays selected': '少なくとも1ページは選択されたままになります',
  'No page matches “{query}”.': '「{query}」に一致するページはありません。',
  'Applies to every tab. At least one page stays selected.':
    'すべてのタブに適用されます。少なくとも1ページは選択されたままになります。',
  Daily: '日次',
  Weekly: '週次',
  Monthly: '月次',
  Quarterly: '四半期',
  Yearly: '年次',
  day: '日',
  week: '週',
  month: '月',
  quarter: '四半期',
  year: '年',
  Mo: '月',
  Monday: '月曜日',
  Tu: '火',
  Tuesday: '火曜日',
  We: '水',
  Wednesday: '水曜日',
  Th: '木',
  Thursday: '木曜日',
  Fr: '金',
  Friday: '金曜日',
  Sa: '土',
  Saturday: '土曜日',
  Su: '日',
  Sunday: '日曜日',
  'Choose a {unit}': '{unit}を選択',
  'Week {n}': '第{n}週',
  'full report': 'フルレポートあり',
  'check failed': '計測失敗',
  'nothing measured': '計測なし',
  '{name}, nothing measured': '{name}、計測なし',
  '{year} Q{q}, {from} to {to}': '{year}年 第{q}四半期（{from}〜{to}）',
  '{n} of {total} pages': '{total}ページ中{n}ページ',
  'Needs attention': '対応が必要',
  'lowest first': '低い順',
  'Nothing to list — this window did not load.':
    '表示するものはありません — この期間を読み込めませんでした。',
  'Nothing was measured in this window, so there is nothing to list.':
    'この期間は計測がないため、表示するものはありません。',
  'Open the detail for {page}': '{page}の詳細を開く',
  'Page detail': 'ページの詳細',
  '{n} thing needs attention': '対応が必要なもの{n}件',
  '{n} things need attention': '対応が必要なもの{n}件',
  'across {n} page': '{n}ページで',
  'across {n} pages': '{n}ページで',
  Measurements: '計測',
  'See coverage: what was measured per hotel, page and device':
    '計測範囲を見る：ホテル・ページ・デバイスごとの計測内容',
  'See coverage': '計測範囲を見る',
  'See why {n} of {total} measurements failed': '{total}件中{n}件の計測が失敗した理由を見る',
  'Every check finished': 'すべての計測が完了',
  '{n} of {total} checks failed.': '{total}件中{n}件の計測が失敗しました。',
  'Performance score': 'パフォーマンススコア',
  'Could not load {what}.': '{what}を読み込めませんでした。',
  'No measurements stored for {what}.': '{what}の計測は保存されていません。',
  'This window was measured, but not on any of the pages the filter keeps.':
    'この期間は計測されていますが、フィルターで選んだページの計測はありません。',
  'The newest stored {unit} is {when}.': '保存されている最新の{unit}は{when}です。',
  'Pick another date above.': '上で別の日付を選んでください。',
  'Show all pages': 'すべてのページを表示',
  'Show the latest {unit}': '最新の{unit}を表示',
  'Every check in this window failed ({failed} of {total}).':
    'この期間の計測はすべて失敗しました（{total}件中{failed}件）。',
  'So there’s no score to show. The Fails card below says why each one failed.':
    'そのため表示できるスコアはありません。下の「失敗」カードで、それぞれの失敗理由を確認できます。',
  'the day before': '前日',
  'the week before': '前週',
  'the month before': '前月',
  'the quarter before': '前四半期',
  'the year before': '前年',
  'the previous window': '前の期間',
  '{a}, no score on {name} to compare with': '{a}、比較できる{name}のスコアなし',
  '{a}, no score in {name} to compare with': '{a}、比較できる{name}のスコアなし',
  '{a}, no score for {name} to compare with': '{a}、比較できる{name}のスコアなし',
  '{a}, no real change since {name} (was {b})': '{a}、{name}から実質的な変化なし（前回 {b}）',
  '{points} since {name} ({b} → {a})': '{name}から{points}（{b} → {a}）',
  '+{n} more failed': 'ほか{n}件の失敗',
  '+{n} more {range}': 'ほか{n}件（{range}）',
  '+{n} more slower': 'ほか{n}件の低下',
  '{failed} of {attempted} attempted. A failed check has no score, so it is left out of every median rather than counted as zero.':
    '{attempted}件中{failed}件。失敗した計測にはスコアがないため、ゼロとして数えず、すべての中央値から除外しています。',
  'See why {what}': '原因を見る：{what}',
  '{lost} of {attempted} failed': '{attempted}件中{lost}件失敗',
  Poor: '不良',
  Open: '開く',
  Slower: '低下',
  '{page} on {device}': '{page}（{device}）',
  'Compare {page} with {against}': '{page}を{against}と比較',
  'Nothing needs attention — no failures, no page {range}, nothing slower beyond ±{noise}.':
    '対応が必要なものはありません — 失敗なし、{range}のページなし、±{noise}を超える低下なし。',
  'Nothing needs attention — no failures and no page {range}. There is no earlier window to compare against.':
    '対応が必要なものはありません — 失敗なし、{range}のページなし。比較できる以前の期間はありません。',
  '{n} point': '{n}ポイント',
  '{n} points': '{n}ポイント',
  '{n} measurement did not finish': '{n}件の計測が完了しませんでした',
  '{n} measurements did not finish': '{n}件の計測が完了しませんでした',
  'Across all pages': 'すべてのページ',
  'On {page}': '{page}',
  'Across {n} of {total} pages': '{total}ページ中{n}ページ',
  'no measurement finished': '完了した計測なし',
  'median of {mobile} mobile and {desktop} desktop measurements':
    'モバイル{mobile}件とデスクトップ{desktop}件の計測の中央値',
  '{n} on {device}': '{device}で{n}件',
  'Every check failed': 'すべての計測が失敗',
  'of {n} attempted': '／{n}件中',
  'all finished': 'すべて完了',
  '{n} of {total}': '{total}件中{n}件',
  'none failed': '失敗なし',
  'the request did not complete': 'リクエストが完了しませんでした',
  'median of {n} measurement per device': 'デバイスごとに{n}件の計測の中央値',
  'median of {n} measurements per device': 'デバイスごとに{n}件の計測の中央値',
  '{n} device': '{n}デバイス',
  '{n} devices': '{n}デバイス',
  Summary: 'サマリー',
  'Per page': 'ページ別',
  Customization: 'カスタマイズ',
  Day: '日',
  Week: '週',
  Month: '月',
  Quarter: '四半期',
  Year: '年',
  'Not available right now': '現在ご利用いただけません',
  'Nothing measured yet': 'まだ計測されていません',
  'The latest check, {when}, did not finish: none of it scored.':
    '最新の計測（{when}）は完了せず、スコアは得られませんでした。',
  'What failed · {group}': '失敗した計測 · {group}',
  'Every measurement, per hotel, page and device': 'ホテル・ページ・デバイスごとのすべての計測',
  '{n} measured': '{n}件計測',
  'Export failed: {message}': '書き出しに失敗しました：{message}',
  'A file for AI review, or a spreadsheet': 'AIレビュー用のファイル、またはスプレッドシート',
  'For AI review': 'AIレビュー用',
  'One Markdown file to give an AI: how to read the numbers, the bw3 releases, daily medians, and every check with what Lighthouse flagged.':
    'AIに渡すMarkdownファイル1つ：数値の読み方、bw3のリリース、日ごとの中央値、そしてLighthouseの指摘つきの全計測。',
  'Two weeks · {range}': '2週間 · {range}',
  'This window · {range}': 'この期間 · {range}',
  'Download for AI': 'AI用にダウンロード',
  'Spreadsheet (CSV)': 'スプレッドシート（CSV）',
  'Every measurement in this window, as stored.':
    'この期間のすべての計測を、保存されたままの形で。',
  'Download CSV': 'CSVをダウンロード',
  Diagnostics: '診断',
  'Diagnostics views': '診断の表示',
  'Nothing was measured in this window, so there is nothing to export':
    'この期間は計測がないため、書き出すものがありません',
  'Exporting…': '書き出し中…',
  Export: '書き出し',
  // ---------------------------------------------------------------- Diagnostics: Per page, the day panel and the analyses
  'grey: within ±{noise}, the same score': 'グレー：±{noise}以内、同じスコア',
  'green: faster by more than ±{noise}': '緑：±{noise}を超えて速くなった',
  'red: slower by more than ±{noise}': '赤：±{noise}を超えて遅くなった',
  'Per page summary': 'ページ別サマリー',
  '{label} against {other}': '{label}（比較：{other}）',
  'No page was measured in {label}.': '{label}に計測されたページはありません。',
  'this window': 'この期間',
  'See why': '原因を見る',
  'Click a page to see what changed on it, metric by metric.':
    'ページをクリックすると、指標ごとに何が変わったかを確認できます。',
  Compare: '比較',
  Mobile: 'モバイル',
  Desktop: 'デスクトップ',
  'Mobile against desktop': 'モバイルとデスクトップの比較',
  'Analysis: {view}': '分析：{view}',
  'Where you are': '現在の位置',
  'This window': 'この期間',
  Analysis: '分析',
  "Average of {n} measurements, ±{noise} run to run. Arcs are coloured by each metric's own sub-score.":
    '{n}件の計測の平均、計測ごとに±{noise}。円弧は各指標のサブスコアで色分けしています。',
  'Where the points went': '失われたポイントの内訳',
  '{weight}% of the score': 'スコアの{weight}%',
  '{n} points lost': '{n}ポイント減',
  "Each metric costs its weight times what its sub-score falls short of 100. Sub-scores are Lighthouse's own scoring curves applied to the stored medians.":
    '各指標の減点は「重み × サブスコアが100に届かない分」です。サブスコアは、保存した中央値に Lighthouse 自身の採点曲線を当てはめたものです。',
  Copied: 'コピーしました',
  'Copy failed: select and copy the preview instead':
    'コピーできませんでした。プレビューを選択してコピーしてください',
  'Not sent. {message}': '送信されませんでした。{message}',
  'What to fix': '修正すべき点',
  'Analyse the fix': '修正点を分析',
  'Lighthouse recorded nothing to fix in this window.':
    'この期間、Lighthouse が修正すべき点として記録したものはありません。',
  Result: '結果',
  Check: 'チェック項目',
  'Seen on': '検出ページ',
  Team: '担当チーム',
  Details: '詳細',
  '+{n} more': 'ほか{n}件',
  'Not routed': '担当未設定',
  'Hide what to do about {check}': '{check}の対処を閉じる',
  'Show what to do about {check}': '{check}の対処を表示',
  'What it means': '意味',
  'What to do · our guidance': '対処 · 社内ガイド',
  "Estimated gain · Lighthouse's estimate": '改善見込み · Lighthouse の推定',
  Who: '担当',
  'No routing rule matches this check yet.':
    'このチェック項目に該当する担当ルールはまだありません。',
  "Savings are Lighthouse's estimates per check and are never added together.":
    '改善見込みはチェック項目ごとの Lighthouse の推定値で、合算はしていません。',
  'Copy as Markdown': 'Markdown でコピー',
  'Send to my Slack…': '自分の Slack に送る…',
  'Sent to your Slack DMs': 'Slack の DM に送信しました',
  'This exact message goes to your Slack DMs': 'このメッセージがそのまま Slack の DM に届きます',
  'Only you receive it. The teams named are not notified.':
    '受け取るのはあなただけです。記載のチームには通知されません。',
  'Sending…': '送信中…',
  Send: '送信',
  Cancel: 'キャンセル',
  'Desktop averages {desktop} and mobile {mobile}, {gap} points apart. {parts}.':
    'デスクトップの平均は{desktop}、モバイルは{mobile}で、差は{gap}ポイントです。{parts}。',
  '{metric} accounts for {points}': '{metric}が{points}',
  'mobile average': 'モバイル平均',
  'desktop average': 'デスクトップ平均',
  'points apart · beyond the noise': 'ポイント差 · ノイズを超える',
  'points apart · within the noise': 'ポイント差 · ノイズの範囲内',
  Metric: '指標',
  Weight: '重み',
  'Points of the gap': '差のポイント',
  Total: '合計',
  'Lighthouse does not measure the two devices on equal terms. Mobile runs with {mobile}; desktop with {desktop}. Part of what follows is that deliberate handicap rather than anything our code does.':
    'Lighthouse は2つのデバイスを同じ条件で計測していません。モバイルは{mobile}、デスクトップは{desktop}で計測します。以下の差の一部は、自社のコードではなく、この意図的なハンデによるものです。',
  'Lighthouse does not measure the two devices on equal terms. Mobile runs with {mobile}. Part of what follows is that deliberate handicap rather than anything our code does.':
    'Lighthouse は2つのデバイスを同じ条件で計測していません。モバイルは{mobile}で計測します。以下の内容の一部は、自社のコードではなく、この意図的なハンデによるものです。',
  Fails: '不合格',
  'Lighthouse fails this check and estimates that fixing it would save time on a metric.':
    'Lighthouse はこのチェック項目を不合格とし、修正すればいずれかの指標の時間が短縮されると推定しています。',
  Flagged: '要確認',
  'Lighthouse flags this check, but estimates no metric would get faster from fixing it.':
    'Lighthouse はこのチェック項目を指摘していますが、修正しても速くなる指標はないと推定しています。',
  Passes: '合格',
  'Lighthouse passes this check.': 'Lighthouse はこのチェック項目を合格としています。',
  Info: '情報',
  'Lighthouse reports this check without passing or failing it.':
    'Lighthouse はこのチェック項目を合否なしで報告しています。',
  '1 check has no rule yet, and is listed as unrouted rather than guessed.':
    '1件のチェック項目にはまだルールがないため、推測せず「担当未設定」として表示しています。',
  '{n} checks have no rule yet, and are listed as unrouted rather than guessed.':
    '{n}件のチェック項目にはまだルールがないため、推測せず「担当未設定」として表示しています。',
  'about {value} off {metric}': '{metric}を約{value}短縮',
  '{metric} scored {sub} of 100, costing {lost} points':
    '{metric}は100点中{sub}点で、{lost}ポイントの減点',
  '{n}× CPU slowdown': 'CPU {n}倍低速化',
  'no CPU slowdown': 'CPU 低速化なし',
  '{rtt}ms round trip, {speed}, {cpu}': '往復 {rtt}ms、{speed}、{cpu}',
  'Also measured · Chrome UX Report · real guests, last 28 days':
    '参考 · Chrome UX レポート · 実際のゲスト、過去28日間',
  'No data from Chrome for {device}.': '{device}の Chrome のデータはありません。',
  '{footer}.': '{footer}。',
  'What real Chrome users got over 28 days, on their own devices. Not in the score, and not the same kind of number as the lab metrics above: that is the slowest quarter of real visits.':
    '実際の Chrome ユーザーが、自分の端末で過去28日間に体験した数値です。スコアには含まれず、上のラボ指標とは種類の違う数値です。実際の訪問のうち遅い方から4分の1にあたる値です。',
  Trend: '推移',
  'Nothing was measured in this bucket.': 'この区間には計測がありません。',
  'Analyse {device}': '{device}を分析',
  '{device} performance analysis': '{device}のパフォーマンス分析',
  Analyse: '分析',
  '{n} failed': '{n}件失敗',
  'from {count}': '{count}から算出',
  'Nothing was measured on this page in the trend window.':
    '推移の期間中、このページの計測はありません。',
  'Shaded: ±{band} run to run': '網掛け：計測ごとの±{band}',
  'Performance score over time': 'パフォーマンススコアの推移',
  '{n} failed on {device}': '{device}で{n}件失敗',
  'this day': 'この日',
  'No audit details were stored for {label}, so its scores cannot be broken down.':
    '{label}の監査の詳細が保存されていないため、スコアの内訳を出せません。',
  'No audit details were stored for {device} on {label}, so that score cannot be broken down.':
    '{label}の{device}の監査の詳細が保存されていないため、そのスコアの内訳を出せません。',
  'The newest day has no score, so this is the latest day that does.':
    '最新の日にはスコアがないため、スコアのある直近の日を表示しています。',
  'The newest week has no score, so this is the latest week that does.':
    '最新の週にはスコアがないため、スコアのある直近の週を表示しています。',
  'The newest month has no score, so this is the latest month that does.':
    '最新の月にはスコアがないため、スコアのある直近の月を表示しています。',
  'The newest quarter has no score, so this is the latest quarter that does.':
    '最新の四半期にはスコアがないため、スコアのある直近の四半期を表示しています。',
  'The newest year has no score, so this is the latest year that does.':
    '最新の年にはスコアがないため、スコアのある直近の年を表示しています。',
  'The {n} newest days have no score, so this is the latest day that does.':
    '直近{n}日間にはスコアがないため、スコアのある直近の日を表示しています。',
  'The {n} newest weeks have no score, so this is the latest week that does.':
    '直近{n}週間にはスコアがないため、スコアのある直近の週を表示しています。',
  'The {n} newest months have no score, so this is the latest month that does.':
    '直近{n}か月にはスコアがないため、スコアのある直近の月を表示しています。',
  'The {n} newest quarters have no score, so this is the latest quarter that does.':
    '直近{n}四半期にはスコアがないため、スコアのある直近の四半期を表示しています。',
  'The {n} newest years have no score, so this is the latest year that does.':
    '直近{n}年間にはスコアがないため、スコアのある直近の年を表示しています。',
  'No measurement finished, so there is no median.{lost}':
    '完了した計測がないため、中央値はありません。{lost}',
  '{count} per device': 'デバイスごとに{count}',
  '{mobile} mobile and {desktop} desktop measurements':
    'モバイル{mobile}件とデスクトップ{desktop}件の計測',
  'Each figure is the median of {of} that finished, not a single page load.{lost}':
    '各数値は、完了した{of}の中央値で、1回のページ読み込みの値ではありません。{lost}',
  'Each figure is the median of {of}, not a single page load.{lost}':
    '各数値は{of}の中央値で、1回のページ読み込みの値ではありません。{lost}',
  '{device} not measured': '{device}は未計測',
  '{device} from {from} to {to}': '{device}は{from}から{to}',
  'A gap is a bucket with no successful measurement.': '空白は成功した計測のない区間です。',
  'Score of {page} over {span}: {lines}, each ±{noise} run to run.{gaps}':
    '{span}の{page}のスコア：{lines}。いずれも計測ごとに±{noise}。{gaps}',
  'Score of {page}: {lines}, each ±{noise} run to run.{gaps}':
    '{page}のスコア：{lines}。いずれも計測ごとに±{noise}。{gaps}',
  '{n} of {total} failed and is left out.': '{total}件中{n}件が失敗し、除外しています。',
  '{n} of {total} failed and are left out.': '{total}件中{n}件が失敗し、除外しています。',
  'When the first text or image shows up': '最初のテキストや画像が表示されるまで',
  'When the biggest thing on the screen finishes loading, usually the main image':
    '画面で最も大きい要素（多くはメイン画像）の読み込みが終わるまで',
  'How long the page was frozen and ignored taps': 'ページが固まり、タップに反応しなかった時間',
  'How quickly the page fills in': 'ページの内容がどれだけ速く表示されるか',
  'How long the server took to send its response headers':
    'サーバーがレスポンスヘッダーを返すまでの時間',
  'How much the page jumps around while it loads':
    '読み込み中にページのレイアウトがどれだけずれるか',
  'What real guests waited for the biggest thing on the screen':
    '実際のゲストが画面で最も大きい要素を待った時間',
  'How long a real tap took to show a response. A lab run never taps, so this one exists only here':
    '実際のタップから反応が表示されるまでの時間。ラボ計測ではタップしないため、この指標はここにしかありません',
  'How much the page jumped around for real guests':
    '実際のゲストにとってページのレイアウトがどれだけずれたか',
  'When real guests first saw anything': '実際のゲストが最初に何かを目にするまで',
  'How long the server took to answer real guests': 'サーバーが実際のゲストに応答するまでの時間',
  'Real guests, 75th percentile': '実際のゲスト、75パーセンタイル',
  'Good up to {good}, poor past it.': '{good}までは良好、それを超えると不良。',
  'Good up to {good}, poor past {poor}.': '{good}までは良好、{poor}を超えると不良。',
  '{value} on {device} — {grade}': '{device}で{value} — {grade}',
  'Not measured on {device}': '{device}では未計測',
  '{value} — {grade} · {footer}': '{value} — {grade} · {footer}',
  '{n} of {total} attempted on {label}, across {hotels} and {pages}.':
    '{label}に{total}件中{n}件を計測（{hotels}、{pages}）。',
  '{n} measurement': '{n}件の計測',
  '{n} measurements': '{n}件の計測',
  days: '日',
  weeks: '週',
  months: 'か月',
  quarters: '四半期',
  years: '年',
  '{head}; failed days show as gaps, never as zero.':
    '{head}。失敗した日は空白で表示し、ゼロにはしません。',
  '{n} of {total} days has no score': '{total}日中{n}日はスコアなし',
  '{n} of {total} days have no score': '{total}日中{n}日はスコアなし',
  '{head}; failed weeks show as gaps, never as zero.':
    '{head}。失敗した週は空白で表示し、ゼロにはしません。',
  '{n} of {total} weeks has no score': '{total}週中{n}週はスコアなし',
  '{n} of {total} weeks have no score': '{total}週中{n}週はスコアなし',
  '{head}; failed months show as gaps, never as zero.':
    '{head}。失敗した月は空白で表示し、ゼロにはしません。',
  '{n} of {total} months has no score': '{total}か月中{n}か月はスコアなし',
  '{n} of {total} months have no score': '{total}か月中{n}か月はスコアなし',
  '{head}; failed quarters show as gaps, never as zero.':
    '{head}。失敗した四半期は空白で表示し、ゼロにはしません。',
  '{n} of {total} quarters has no score': '{total}四半期中{n}四半期はスコアなし',
  '{n} of {total} quarters have no score': '{total}四半期中{n}四半期はスコアなし',
  '{head}; failed years show as gaps, never as zero.':
    '{head}。失敗した年は空白で表示し、ゼロにはしません。',
  '{n} of {total} years has no score': '{total}年中{n}年はスコアなし',
  '{n} of {total} years have no score': '{total}年中{n}年はスコアなし',
  '{name}, no score in this span': '{name}、この期間のスコアなし',
  '{name} {value} ±{noise}, the newest score, {at}': '{name} {value} ±{noise}、最新のスコア{at}',
  '{head}; they are left out of the score, never counted as zero.':
    '{head}。スコアから除外しており、ゼロとして数えていません。',
  'Nothing was measured in {label}.': '{label}は計測されていません。',
  'on {label}': '（{label}）',
  'in {label}': '（{label}）',
  'Mobile {m} and desktop {d} {at}': 'モバイル {m}、デスクトップ {d}{at}',
  'Mobile {m} {atm} and desktop {d} {atd}': 'モバイル {m}{atm}、デスクトップ {d}{atd}',
  '{name} {value} {at}; {other} has no score in this span':
    '{name} {value}{at}。{other}はこの期間のスコアなし',
  'lowest {device} {value} {at}': '{device}の最低 {value}{at}',
  '{n} of {total} {unit} has no score': '{total}{unit}中{n}{unit}はスコアなし',
  'every score ±{noise}': 'いずれのスコアも±{noise}',
  '{parts}.': '{parts}。',
  '{failed} of {n} measurement failed in this span': 'この期間の{n}件の計測のうち{failed}件が失敗',
  '{failed} of {n} measurements failed in this span': 'この期間の{n}件の計測のうち{failed}件が失敗',
  'No score in {label}: {failed} of {n} measurement failed.':
    '{label}はスコアなし：{n}件中{failed}件の計測が失敗。',
  'No score in {label}: {failed} of {n} measurements failed.':
    '{label}はスコアなし：{n}件中{failed}件の計測が失敗。',
  'All hotels': 'すべてのホテル',
  'This hotel has no group in the report, so it has no card on the Customization tab.':
    'このホテルはレポートでグループが設定されていないため、カスタマイズタブにカードがありません。',
  'No card to open': '開けるカードなし',
  'Open {where}': '{where}を開く',
  '{hotel} on {page}, {device}': '{hotel}の{page}（{device}）',
  'Open hotel': 'ホテルを開く',
  'Metrics, {before} against {now}': '指標（{before}と{now}の比較）',
  Change: '変化',
  '{means}. Lighthouse sets no bar for it, so it is not graded.':
    '{means}。Lighthouse が基準を定めていないため、評価していません。',
  'Checking what landed…': 'リリースを確認中…',
  'Could not load the releases': 'リリースを読み込めませんでした',
  window: '期間',
  'between the two checks': '2回の計測の間',
  'this {unit}': 'この{unit}',
  'Nothing shipped {where}': '{where}のリリースなし',
  'the time between the two checks': '2回の計測の間の時間',
  'Releases recorded for only part of {part}': '{part}の一部しかリリースが記録されていません',
  'Releases weren’t recorded {where}': '{where}のリリースは記録されていません',
  'What landed between the two checks': '2回の計測の間のリリース',
  'What landed · {label}': 'リリース · {label}',
  'What needs attention on {device}': '{device}で対応が必要なもの',
  'Show all {n} on {device}': '{device}の{n}件をすべて表示',
  '{n} need attention': '対応が必要なもの{n}件',
  '{n} release landed {where}': '{where}に{n}件のリリース',
  '{n} releases landed {where}': '{where}に{n}件のリリース',
  'What shipped in this window': 'この期間のリリース',
  '{value} on {device}. Lighthouse sets no bar for it, so it is not graded':
    '{device}で{value}。Lighthouse が基準を定めていないため、評価していません',
  'last run': '前回',
  'last week': '先週',
  'last month': '先月',
  'last quarter': '前四半期',
  'last year': '昨年',
  "These are Lighthouse's own boundaries for this metric on this device.":
    'これは、このデバイスでのこの指標に対する Lighthouse 自身の境界値です。',
  '{from} to {to}': '{from}から{to}',
  'Improved: {words}': '改善：{words}',
  'Two grades worse: {words}': '2段階悪化：{words}',
  'A grade worse: {words}': '1段階悪化：{words}',
  'crossed from {from} back up into {to}': '{from}から{to}に回復しました',
  'crossed from {from} to {to}, two grades in one run':
    '{from}から{to}に変わりました（1回で2段階）',
  'crossed from {from} to {to}': '{from}から{to}に変わりました',
  '{title} {how}. {note}': '{title}は{how}。{note}',
  Unchanged: '変化なし',
  ': all {n} checks failed': '（{n}回の計測がすべて失敗）',
  'the window before': '前の期間',
  '{skipped} had no score (all {n} checks failed), so this compares with {label}, the last with one.':
    '{skipped}はスコアがなかった（{n}回の計測がすべて失敗）ため、スコアのある直近の{label}と比較しています。',
  '{skipped} had no score, so this compares with {label}, the last with one.':
    '{skipped}はスコアがなかったため、スコアのある直近の{label}と比較しています。',
  'Nothing to compare.': '比較できません。',
  '{label} has no score for this page{failed}.':
    '{label}はこのページのスコアがありません{failed}。',
  'Nothing to compare against.': '比較対象がありません。',
  '{label} has no measurement for this page{failed}, and no earlier one has a score.':
    '{label}にはこのページの計測がなく{failed}、それ以前にもスコアのある期間がありません。',
  'The window before': '前の期間',
  'Score held steady, but {metrics} changed grade.':
    'スコアは横ばいですが、{metrics}の評価が変わりました。',
  Identical: '同一',
  'to {name}, metric for metric.{over}': '{name}と指標ごとに同じです。{over}',
  'Held steady.': '横ばい。',
  'Every metric stayed in the grade it was in.{over}': 'すべての指標が同じ評価のままでした。{over}',
  '{move}, beyond the ±{noise} noise.': '{move}（±{noise}のノイズを超える変化）。',
  '{before} on {name}, {now} now.{over}': '{name}は{before}、現在は{now}。{over}',
  'previous {unit}': '前の{unit}',
  yesterday: '昨日',
  today: '今日',
  '{label} against the last window each device has a score for':
    '{label}（比較：各デバイスでスコアのある直近の期間）',
  'between the check at {since} and the check at {until}': '{since}の計測から{until}の計測までの間',
  '{count}.': '{count}。',
  '{count}. The list may be incomplete: releases were not recorded for all of it.':
    '{count}。リリースが全期間で記録されていないため、一覧は不完全な可能性があります。',
  'Nothing shipped {between}.': '{between}にリリースはありませんでした。',
  'Releases were recorded for only part of the time {between}, and none landed in that part.':
    '{between}のうち一部の時間しかリリースが記録されておらず、その間にリリースはありませんでした。',
  'Releases were not recorded {between}, so this cannot say whether anything shipped.':
    '{between}はリリースが記録されていないため、リリースの有無はわかりません。',
  ' up to {when}, when releases were last checked': '（リリースを最後に確認した{when}まで）',
  '{count}{upTo}.': '{count}{upTo}。',
  'Nothing shipped on {label}.': '{label}にリリースはありませんでした。',
  'Nothing shipped in {label}.': '{label}にリリースはありませんでした。',
  'Nothing shipped on {label}{upTo}.': '{label}{upTo}にリリースはありませんでした。',
  'Nothing shipped in {label}{upTo}.': '{label}{upTo}にリリースはありませんでした。',
  'Releases were recorded for only part of {label}, and none landed in that part.':
    '{label}は一部の時間しかリリースが記録されておらず、その間にリリースはありませんでした。',
  'Releases were not recorded for {label}, so this cannot say whether anything shipped.':
    '{label}はリリースが記録されていないため、リリースの有無はわかりません。',
  'No releases recorded on {label}.': '{label}のリリース記録はありません。',
  'No releases recorded in {label}.': '{label}のリリース記録はありません。',
  '{n} release landed {between}': '{between}に{n}件のリリース',
  '{n} releases landed {between}': '{between}に{n}件のリリース',
  '{n} release landed on {label}': '{label}に{n}件のリリース',
  '{n} releases landed on {label}': '{label}に{n}件のリリース',
  '{n} release landed in {label}': '{label}に{n}件のリリース',
  '{n} releases landed in {label}': '{label}に{n}件のリリース',
  'no score': 'スコアなし',
  'Every check in this window failed — {failed} of {attempted}.':
    'この期間の計測はすべて失敗しました（{attempted}件中{failed}件）。',
  '{failed} of {attempted} checks failed in this window and are left out of the scores.':
    'この期間、{attempted}件中{failed}件の計測が失敗し、スコアから除外しています。',
  '{head} Where every check on a page failed, a dashed “failed” mark stands in for its bar.':
    '{head} ページの計測がすべて失敗した場合は、バーの代わりに「失敗」を示す破線を表示します。',
  'Performance score per page out of 100, ±{noise} run to run, this window against {previous}. {rows}.':
    'ページ別のパフォーマンススコア（100点満点、計測ごとに±{noise}）、この期間と{previous}の比較。{rows}。',
  '{page}: mobile {mobile}, desktop {desktop}': '{page}：モバイル {mobile}、デスクトップ {desktop}',
  'Report to Slack': 'Slack に報告',
  'Preview — Slack is not connected yet, so nothing is sent. Copy it and post it for now; later this opens a thread that mentions the owner. The message is in English, as the channel reads it.':
    'プレビュー — Slack とはまだ連携していないため、何も送信されません。今はコピーして投稿してください。今後は担当者にメンションするスレッドが作成されます。チャンネルに合わせて、メッセージは英語です。',
  'Copy message': 'メッセージをコピー',
  'Not connected yet — copy the message for now': '未連携です — 今はメッセージをコピーしてください',
  'Send to Slack': 'Slack に送信',
  // ---------------------------------------------------------------- Diagnostics: Customization and the hotel views
  'Every one of {attempted} measurements failed: each bar is a dashed “failed” mark, not a score.':
    '{attempted}件の計測がすべて失敗しました。各バーはスコアではなく、「失敗」を示す破線です。',
  '{failed} of {attempted} measurements failed: their bars are gaps, not zeros.':
    '{attempted}件中{failed}件の計測が失敗しました。そのバーはゼロではなく空白です。',
  '{a} and {b}': '{a}と{b}',
  '{hotels} hotels and {n} colours, so {named} share a hue. Hide one of each pair in the legend to tell them apart.':
    'ホテル{hotels}軒に対して色が{n}色のため、{named}は同じ色になります。区別するには、凡例で各組の一方を非表示にしてください。',
  '{note}.': '{note}。',
  'Back to pages.': 'ページ一覧に戻りました。',
  'Showing {page}: every complex hotel’s score by {unit}, mobile and desktop.':
    '{page}を表示中：複雑なカスタマイズのホテルすべての{unit}ごとのスコア（モバイルとデスクトップ）。',
  'Showing {page}: every normal hotel’s score by {unit}, mobile and desktop.':
    '{page}を表示中：通常カスタマイズのホテルすべての{unit}ごとのスコア（モバイルとデスクトップ）。',
  '{hotel} on {page}, {day}: mobile and desktop side by side.':
    '{hotel}の{page}、{day}：モバイルとデスクトップを並べて表示。',
  'Measurements for {day}, mobile and desktop.': '{day}の計測（モバイルとデスクトップ）。',
  '{group}, by page': '{group}、ページ別',
  '{page} over time': '{page}の推移',
  'One page over time': '1ページの推移',
  'Measurements for {day}': '{day}の計測',
  'One day’s measurements': '1日分の計測',
  '{hotel}, mobile and desktop': '{hotel}、モバイルとデスクトップ',
  'One hotel': '1軒のホテル',
  'See what failed': '失敗した計測を見る',
  'An arrow:': '矢印：',
  'moved by at least the noise band since the previous {unit}': '前の{unit}からノイズ幅以上変化',
  'What the cells and arrows mean': 'セルと矢印の意味',
  'Each cell is that hotel’s score for the {unit}: the median of its successful runs in it. An arrow means the score moved by at least the noise band since the {unit} before; no arrow, that it moved less, or that one of the two has no score. A — is a {unit} with no score: it failed or was not measured, and its measurements say which. Click a {unit} for them.':
    '各セルは、その{unit}のホテルのスコア（成功した計測の中央値）です。矢印は、前の{unit}からノイズ幅以上スコアが変化したことを示します。矢印がない場合は、変化がそれより小さいか、どちらかにスコアがありません。— はスコアのない{unit}で、失敗か未計測かは計測一覧でわかります。{unit}をクリックすると表示されます。',
  '{n} hotel': '{n}軒のホテル',
  '{n} hotels': '{n}軒のホテル',
  '{n} page': '{n}ページ',
  '{n} pages': '{n}ページ',
  'outside the filter': 'フィルター対象外',
  'not measured in this window': 'この期間は未計測',
  '{page} ({why})': '{page}（{why}）',
  'Open a page': 'ページを開く',
  'Pick a {unit}': '{unit}を選択',
  'Pick a hotel': 'ホテルを選択',
  'Back to the day’s measurements': 'その日の計測に戻る',
  'Back to {page} over time': '{page}の推移に戻る',
  'Back to pages': 'ページ一覧に戻る',
  '{label}: where you are': '{label}：現在の位置',
  Page: 'ページ',
  Hotel: 'ホテル',
  '{page} is outside the page filter, so this hotel’s rows are not loaded. Add it to the filter to see its scores and what Lighthouse flags.':
    '{page}はページフィルターの対象外のため、このホテルの行は読み込まれていません。スコアと Lighthouse の指摘を見るには、フィルターに追加してください。',
  'No score': 'スコアなし',
  'Not measured': '未計測',
  Up: '上昇',
  Down: '低下',
  'No measurement of a complex hotel on {where} was stored for {label}.':
    '{label}の{where}について、複雑なカスタマイズのホテルの計測は保存されていません。',
  'No measurement of a normal hotel on {where} was stored for {label}.':
    '{label}の{where}について、通常カスタマイズのホテルの計測は保存されていません。',
  '{pages} is outside the page filter, so its rows are not loaded. Add it to the filter to list its rows here.':
    '{pages}はページフィルターの対象外のため、行は読み込まれていません。ここに表示するには、フィルターに追加してください。',
  '{pages} are outside the page filter, so their rows are not loaded. Add them to the filter to list their rows here.':
    '{pages}はページフィルターの対象外のため、行は読み込まれていません。ここに表示するには、フィルターに追加してください。',
  'Rows behind {label}': '{label}の内訳',
  Device: 'デバイス',
  Measured: '計測日時',
  Score: 'スコア',
  Notes: 'メモ',
  Report: 'レポート',
  'Open {hotel}’s page as it was measured (new tab)': '{hotel}の計測したページを開く（新しいタブ）',
  'Open {hotel}: mobile and desktop against the other complex hotels':
    '{hotel}を開く：モバイルとデスクトップを他の複雑なカスタマイズのホテルと比較',
  'Open {hotel}: mobile and desktop against the other normal hotels':
    '{hotel}を開く：モバイルとデスクトップを他の通常カスタマイズのホテルと比較',
  Failed: '失敗',
  'What to check': '確認すること',
  'More notes for {hotel}, {device}': '{hotel}（{device}）のメモをもっと見る',
  More: 'もっと見る',
  'Open in PageSpeed (fresh run)': 'PageSpeed で開く（新たに計測）',
  'Open in PageSpeed (fresh run, not this stored one): {hotel}, {device}':
    'PageSpeed で開く（保存済みの結果ではなく新たに計測）：{hotel}、{device}',
  to: '→',
  'Metrics that changed grade': '評価が変わった指標',
  'Loading {what}…': '{what}を読み込み中…',
  'Could not load {what} to compare.': '比較のための{what}を読み込めませんでした。',
  'Not compared: one of the two days has no successful run to read.':
    '比較なし：どちらかの日に成功した計測がありません。',
  'No metric changed grade.': '評価が変わった指標はありません。',
  'Pull request {ref}': 'プルリクエスト {ref}',
  'Jira {ref}': 'Jira {ref}',
  'Loading the releases…': 'リリースを読み込み中…',
  'Could not load the releases for that {unit}.': 'その{unit}のリリースを読み込めませんでした。',
  'No releases recorded that {unit}.': 'その{unit}のリリース記録はありません。',
  Failure: '失敗',
  Error: 'エラー',
  '{n} point since {since}': '{since}から{n}ポイント',
  '{n} points since {since}': '{since}から{n}ポイント',
  'this span': 'この期間',
  'No complex hotel is listed on {page} in {span}.':
    '{span}の{page}には、複雑なカスタマイズのホテルがありません。',
  'No normal hotel is listed on {page} in {span}.':
    '{span}の{page}には、通常カスタマイズのホテルがありません。',
  'Scores of every complex hotel on {page}, by {unit}, mobile and desktop. Pick a {unit} for its measurements.':
    '{page}の複雑なカスタマイズのホテルすべての{unit}ごとのスコア（モバイルとデスクトップ）。{unit}を選ぶとその計測を表示します。',
  'Scores of every normal hotel on {page}, by {unit}, mobile and desktop. Pick a {unit} for its measurements.':
    '{page}の通常カスタマイズのホテルすべての{unit}ごとのスコア（モバイルとデスクトップ）。{unit}を選ぶとその計測を表示します。',
  'Open the measurements for {label}': '{label}の計測を開く',
  'Open {hotel}’s {page} as it was measured (new tab)':
    '{hotel}の計測した{page}を開く（新しいタブ）',
  'Hotels on this chart. A name or a device hides it.':
    'このグラフのホテル。名前かデバイスを押すと非表示になります。',
  'Hide or show {hotel} on both devices': '{hotel}を両方のデバイスで表示／非表示',
  'Flags are listed for a daily or weekly window.': '指摘は日次または週次の期間で表示されます。',
  'no complex hotel with audits': '監査データのある複雑なカスタマイズのホテルなし',
  'no normal hotel with audits': '監査データのある通常カスタマイズのホテルなし',
  '{n} of {of} complex hotel with audits':
    '監査データのある複雑なカスタマイズのホテル{of}軒中{n}軒',
  '{n} of {of} complex hotels with audits':
    '監査データのある複雑なカスタマイズのホテル{of}軒中{n}軒',
  '{n} of {of} complex hotel': '複雑なカスタマイズのホテル{of}軒中{n}軒',
  '{n} of {of} complex hotels': '複雑なカスタマイズのホテル{of}軒中{n}軒',
  '{n} of {of} normal hotel with audits': '監査データのある通常カスタマイズのホテル{of}軒中{n}軒',
  '{n} of {of} normal hotels with audits': '監査データのある通常カスタマイズのホテル{of}軒中{n}軒',
  '{n} of {of} normal hotel': '通常カスタマイズのホテル{of}軒中{n}軒',
  '{n} of {of} normal hotels': '通常カスタマイズのホテル{of}軒中{n}軒',
  'Lighthouse insights flagged for at least one complex hotel on {page}, {window}':
    '{window}の{page}で、複雑なカスタマイズのホテル1軒以上に Lighthouse が指摘したインサイト',
  'Lighthouse insights flagged for at least one normal hotel on {page}, {window}':
    '{window}の{page}で、通常カスタマイズのホテル1軒以上に Lighthouse が指摘したインサイト',
  Window: '期間',
  'Compared with': '比較対象',
  'nothing — no peer measured here': 'なし — ここで計測された同じグループのホテルがありません',
  '{n} other complex hotel': '他の複雑なカスタマイズのホテル{n}軒',
  '{n} other complex hotels': '他の複雑なカスタマイズのホテル{n}軒',
  '{n} other normal hotel': '他の通常カスタマイズのホテル{n}軒',
  '{n} other normal hotels': '他の通常カスタマイズのホテル{n}軒',
  'Normal customization': '通常カスタマイズ',
  'Complex customization': '複雑なカスタマイズ',
  'close to the base widget': '標準ウィジェットに近い',
  'customized well away from the base widget': '標準ウィジェットから大きくカスタマイズ',
  'not measured': '未計測',
  failed: '失敗',
  'all {n} failed': '{n}件すべて失敗',
  'Click for this page over time': 'クリックでこのページの推移を表示',
  '{group}: scores out of 100, ±{noise}, for {hotels} on {pages}, mobile striped and desktop solid.':
    '{group}：{pages}における{hotels}のスコア（100点満点、±{noise}）。モバイルは斜線、デスクトップは塗りつぶし。',
  '{what} Lowest: {hotel} on {page}, {device}, {score}.':
    '{what} 最低：{hotel}の{page}、{device}、{score}。',
  '{what} Nothing was measured.': '{what} 計測はありません。',
  'One measurement per run, hotel and device, not a median. Click a row to open that hotel.':
    '1行は計測回・ホテル・デバイスごとの1回の計測で、中央値ではありません。行をクリックするとそのホテルを開きます。',
  'One measurement per hotel and device, not a median. Click a row to open that hotel.':
    '1行はホテル・デバイスごとの1回の計測で、中央値ではありません。行をクリックするとそのホテルを開きます。',
  'Open it in PageSpeed (the Report link) to see whether it happens again on a fresh run.':
    'PageSpeed で開き（レポートのリンク）、新たに計測しても再発するか確認してください。',
  'Open the page yourself: a blank page, a bot check or a crash before the first paint all look like this to Lighthouse.':
    '実際にページを開いて確認してください。白紙のページ、ボット確認、最初の描画前のクラッシュは、Lighthouse にはどれもこう見えます。',
  'Open the page yourself and watch it load: a request or a script that never finishes holds the page up like this.':
    '実際にページを開いて読み込みを見てください。終わらないリクエストやスクリプトがあると、このようにページが止まります。',
  'Open the address yourself: check that it still loads and has not moved or been renamed.':
    '実際に URL を開き、まだ読み込めるか、移動や名前の変更がないか確認してください。',
  'This is PageSpeed Insights refusing or failing the request, not the page: check whether other rows failed the same way at the same time.':
    'これはページではなく、PageSpeed Insights がリクエストを拒否または失敗したものです。他の行も同じ時刻に同じ理由で失敗していないか確認してください。',
  'A later run usually succeeds; open it in PageSpeed (the Report link) to try one now.':
    '通常は後の計測で成功します。今すぐ試すには PageSpeed で開いてください（レポートのリンク）。',
  'Open the page yourself and check that it loads.':
    '実際にページを開き、読み込めるか確認してください。',
  'The hotel had no rooms for the dates searched, so the widget opened another page. One day is availability; every day means its search date needs moving in config/pages.json (RUNBOOK, “A page redirected”).':
    '検索した日程に空室がなかったため、ウィジェットが別のページを表示しました。1日だけなら空室状況の問題です。毎日続く場合は、config/pages.json でそのホテルの検索日を変更してください（RUNBOOK「A page redirected」）。',
  '{points} since {since} ({before} → {after})': '{since}から{points}（{before} → {after}）',
  'the bucket before': '前の区間',
  'Listed because they landed between the two checks, not a claim that they caused it.':
    '2回の計測の間にリリースされたため表示しています。原因であるとは限りません。',
  'Listed because they landed that {unit} — not a claim that they caused it.':
    'その{unit}にリリースされたため表示しています。原因であるとは限りません。',
  Release: 'リリース',
  'Releases between the two checks': '2回の計測の間のリリース',
  'Releases that landed that {unit}': 'その{unit}のリリース',
  '{count}: {first}': '{count}：{first}',
  '{n} release landed between the two checks': '2回の計測の間に{n}件のリリース',
  '{n} releases landed between the two checks': '2回の計測の間に{n}件のリリース',
  '{n} release landed that {unit}': 'その{unit}に{n}件のリリース',
  '{n} releases landed that {unit}': 'その{unit}に{n}件のリリース',
  'At least one stays on': '少なくとも1つは表示したままになります',
  '{hotel}, {device}, {label}': '{hotel}、{device}、{label}',
  '{head}: not measured': '{head}：未計測',
  ' from {since}, the last with a score': '（スコアのある直近の{since}から）',
  ' from {since}': '（{since}から）',
  '{head}: {now}, up {n}{from}': '{head}：{now}、{n}上昇{from}',
  '{head}: {now}, down {n}{from}': '{head}：{now}、{n}低下{from}',
  '{head}: failed — {n} check, none scored': '{head}：失敗 — {n}回の計測すべてスコアなし',
  '{head}: failed — {n} checks, none scored': '{head}：失敗 — {n}回の計測すべてスコアなし',
  '{n} of {total} finished': '{total}件中{n}件完了',
  'every check finished · {n} of {total}': 'すべての計測が完了 · {total}件中{n}件',
  'What was measured': '計測した内容',
  '“Opened …” is a check that asked for one booking page and got the other: the hotel’s page goes by availability on the searched date, so the check is counted under the page that opened.':
    '「…を表示」は、ある予約ページを要求して別のページが表示された計測です。ホテルのページは検索日の空室状況によって変わるため、実際に表示されたページの計測として数えています。',
  'Copy failed': 'コピーできませんでした',
  'What failed': '失敗した計測',
  '{n} of {total} measurements': '{total}件中{n}件の計測',
  nothing: 'なし',
  'Copy as text': 'テキストでコピー',
  'Every check in {label} finished. A failure would be listed here with its reason, and left out of every score rather than counted as zero.':
    '{label}の計測はすべて完了しました。失敗があればここに理由とともに表示し、ゼロとして数えずにすべてのスコアから除外します。',
  'Failed checks are left out of every median, never counted as zero.':
    '失敗した計測はすべての中央値から除外し、ゼロとしては数えていません。',
  'What Lighthouse flags': 'Lighthouse の指摘',
  'How these counts are made': '件数の数え方',
  '{page} is outside the page filter, so its flags are not loaded. Add it to the filter to list them.':
    '{page}はページフィルターの対象外のため、指摘は読み込まれていません。表示するにはフィルターに追加してください。',
  New: '新規',
  'Show the first {n}': '最初の{n}件を表示',
  'Counts are hotels flagged in at least one run in this window. Each run keeps only its 10 worst-rated insights, so a hotel missing from a count may still have the issue.':
    '件数は、この期間に1回以上指摘されたホテルの数です。各計測は評価の低いインサイト10件のみ保存するため、件数に含まれないホテルにも同じ問題がある可能性があります。',
  "Not flagged on this hotel's runs on {label}.":
    '{label}のこのホテルの計測では指摘されていません。',
  "Not flagged on this hotel's runs in the bucket before.":
    '前の区間のこのホテルの計測では指摘されていません。',
  'No earlier run to compare': '比較できる以前の計測なし',
  'Could not load {label} to compare': '比較のための{label}を読み込めませんでした',
  '{n} new since {label}': '{label}から新たに{n}件',
  'None new since {label}': '{label}から新たな指摘なし',
  'no complex hotel measured': '計測された複雑なカスタマイズのホテルなし',
  'no normal hotel measured': '計測された通常カスタマイズのホテルなし',
  '{n} of {of} other complex hotel': '他の複雑なカスタマイズのホテル{of}軒中{n}軒',
  '{n} of {of} other complex hotels': '他の複雑なカスタマイズのホテル{of}軒中{n}軒',
  '{n} of {of} other complex hotel with audits':
    '監査データのある他の複雑なカスタマイズのホテル{of}軒中{n}軒',
  '{n} of {of} other complex hotels with audits':
    '監査データのある他の複雑なカスタマイズのホテル{of}軒中{n}軒',
  'no other complex hotel with audits': '監査データのある他の複雑なカスタマイズのホテルなし',
  'no other complex hotel measured': '計測された他の複雑なカスタマイズのホテルなし',
  '{n} of {of} other normal hotel': '他の通常カスタマイズのホテル{of}軒中{n}軒',
  '{n} of {of} other normal hotels': '他の通常カスタマイズのホテル{of}軒中{n}軒',
  '{n} of {of} other normal hotel with audits':
    '監査データのある他の通常カスタマイズのホテル{of}軒中{n}軒',
  '{n} of {of} other normal hotels with audits':
    '監査データのある他の通常カスタマイズのホテル{of}軒中{n}軒',
  'no other normal hotel with audits': '監査データのある他の通常カスタマイズのホテルなし',
  'no other normal hotel measured': '計測された他の通常カスタマイズのホテルなし',
  "Not compared: none of this hotel's runs names a customization group.":
    '比較なし：このホテルの計測にはカスタマイズのグループが記録されていません。',
  'Also flagged for {counts}': 'ほかに{counts}でも指摘',
  '{n} failed, left out': '{n}件失敗（除外）',
  '{n} kept no insights, left out': '{n}件はインサイトなし（除外）',
  'This hotel was not measured on this page and device in this window, so there is nothing to list.':
    'この期間、このホテルはこのページとデバイスで計測されていないため、表示するものはありません。',
  'No run finished for this hotel on this page in this window — the one run failed — so there are no flags to read.':
    'この期間、このホテルのこのページで完了した計測はありません（1回の計測が失敗）。そのため指摘はありません。',
  'No run finished for this hotel on this page in this window — all {n} runs failed — so there are no flags to read.':
    'この期間、このホテルのこのページで完了した計測はありません（{n}回の計測がすべて失敗）。そのため指摘はありません。',
  'Lighthouse flagged nothing on this page for this hotel in this window.':
    'この期間、このホテルのこのページで Lighthouse が指摘したものはありません。',
  'from {n} run': '{n}回の計測から',
  'from {n} runs': '{n}回の計測から',
  "{n} run finished, but none kept Lighthouse's insights, so there are no flags to read.":
    '{n}回の計測が完了しましたが、Lighthouse のインサイトが保存されていないため、指摘はありません。',
  "{n} runs finished, but none kept Lighthouse's insights, so there are no flags to read.":
    '{n}回の計測が完了しましたが、どれにも Lighthouse のインサイトが保存されていないため、指摘はありません。',
  Standard: '標準',
  Customised: 'カスタマイズ',
  'Unknown group': 'グループ不明',
  'opened {page}': '{page}を表示',
  'See why checks of {hotel} on {page} failed': '{hotel}の{page}の計測が失敗した理由を見る',
  'This check asked for {page}, and the hotel’s page opened {went} instead, so it is counted there. The booking pages go by availability on the searched date.':
    'この計測は{page}を要求しましたが、ホテルのページは代わりに{went}を表示したため、そちらで数えています。予約ページは検索日の空室状況によって変わります。',
  'no reason recorded': '理由の記録なし',
  // ---------------------------------------------------------------- Diagnostics: the full report (deep run)
  'Deep run': '詳細計測',
  'By content type': 'コンテンツの種類別',
  'Bytes by content type': 'コンテンツの種類別のバイト数',
  'Ours and theirs': '自社と他社',
  'Bytes by who serves them': '配信元別のバイト数',
  'Third parties · main-thread time': 'サードパーティ · メインスレッド時間',
  'Requests by response code': 'レスポンスコード別のリクエスト',
  'Third party': 'サードパーティ',
  'Against the largest': '最大との比較',
  'Main-thread time': 'メインスレッド時間',
  Code: 'コード',
  Meaning: '意味',
  'Show the files': 'ファイル一覧を表示',
  'Hide the files': 'ファイル一覧を閉じる',
  'Every file the page loaded · {n}': 'ページが読み込んだすべてのファイル · {n}',
  'Showing the {n} largest of {total}. Addresses are shown without their query strings.':
    '{total}件のうち大きい順に{n}件を表示しています。URL はクエリ文字列を除いて表示しています。',
  Ours: '自社',
  Theirs: '他社',
  '{n} req': '{n}件',
  'Files the page asked for in one load.': '1回の読み込みでページが要求したファイル数。',
  'Data downloaded in one load.': '1回の読み込みでダウンロードしたデータ量。',
  'When the page stops being busy and can answer a tap. Not a load time.':
    'ページの処理が落ち着き、タップに応答できるようになるまでの時間。読み込み時間ではありません。',
  '{device} page weight': '{device}のページの重さ',
  'What {figure} means': '{figure}の意味',
  up: '増加',
  down: '減少',
  'The deep run on {day} has no {device} figures to move against.':
    '{day}の詳細計測には、比較できる{device}の数値がありません。',
  'the earlier day': '以前の日',
  'No earlier deep run to compare with, so nothing here says whether it moved.':
    '比較できる以前の詳細計測がないため、変化の有無はわかりません。',
  Script: 'スクリプト',
  Image: '画像',
  Font: 'フォント',
  Stylesheet: 'スタイルシート',
  Document: 'ドキュメント',
  Other: 'その他',
  OK: 'OK',
  Created: '作成',
  'No content': 'コンテンツなし',
  'Partial content': '部分コンテンツ',
  'Moved permanently': '恒久的に移動',
  Redirected: 'リダイレクト',
  'See other': '他を参照',
  'Not modified': '未更新',
  'Temporary redirect': '一時的なリダイレクト',
  'Permanent redirect': '恒久的なリダイレクト',
  'Bad request': '不正なリクエスト',
  Unauthorised: '認証が必要',
  Forbidden: 'アクセス禁止',
  'Not found': '見つかりません',
  Gone: '削除済み',
  'Too many requests': 'リクエスト過多',
  'Server error': 'サーバーエラー',
  'Bad gateway': '不正なゲートウェイ',
  Unavailable: '利用不可',
  'Gateway timeout': 'ゲートウェイタイムアウト',
  Informational: '情報',
  Success: '成功',
  Redirect: 'リダイレクト',
  'Client error': 'クライアントエラー',
  File: 'ファイル',
  Type: '種類',
  Size: 'サイズ',
  Whose: '配信元',
  Requests: 'リクエスト数',
  '{amount} more requests than {against}.': '{against}よりリクエストが{amount}件多い。',
  '{amount} fewer requests than {against}.': '{against}よりリクエストが{amount}件少ない。',
  Transferred: '転送量',
  '{amount} heavier than {against}.': '{against}より{amount}重い。',
  '{amount} lighter than {against}.': '{against}より{amount}軽い。',
  'Time to interactive': '操作可能になるまでの時間',
  '{amount} later than {against}.': '{against}より{amount}遅い。',
  '{amount} sooner than {against}.': '{against}より{amount}早い。',
  'the previous deep run': '前回の詳細計測',
  '{n} deep-run days in {label}': '{label}の詳細計測日{n}日',
  '{n} more failed and kept nothing.': 'ほかに{n}件が失敗し、何も保存されていません。',
  'Averaged over {counted} on {when}. Moves compare with the previous deep run.{failures}':
    '{when}の{counted}の平均。変化は前回の詳細計測との比較です。{failures}',
  mobile: 'モバイル',
  desktop: 'デスクトップ',
  '{device} only': '{device}のみ',
  'mobile and desktop together': 'モバイルとデスクトップの合計',
  'all {n} checks failed': '{n}回の計測がすべて失敗',
  '{n} of {total} checks failed': '{total}回中{n}回の計測が失敗',
  'It was taken on {day} instead.': '代わりに{day}に取得しました。',
  'It is taken again on the next day whose checks succeed.':
    '計測が成功する次の日に、あらためて取得します。',
  'No full report was kept on {day}: {failed}. {after}':
    '{day}のフルレポートは保存されていません：{failed}。{after}',
  // ---------------------------------------------------------------- Sentences the server sends (test/ui/i18nKeys.js SERVER_SENTENCES)
  '1 week ago': '1週間前',
  '1 month ago': '1か月前',
  '3 months ago': '3か月前',
  '6 months ago': '6か月前',
  '1 year ago': '1年前',
  'Measurement has not run yet.': 'まだ計測していません。',
  'Waiting for the sample to be approved.': 'サンプルの承認待ちです。',
  'We have not looked for a page to measure yet.': '計測するページをまだ探していません。',
  'No mobile check finished in this window, so there is nothing to compare.':
    'この期間に完了したモバイルの計測がないため、比較できません。',
  'No desktop check finished in this window, so there is nothing to compare.':
    'この期間に完了したデスクトップの計測がないため、比較できません。',
  'No mobile or desktop check finished in this window, so there is nothing to compare.':
    'この期間に完了したモバイル・デスクトップの計測がないため、比較できません。',
  'No mobile check finished in this window, so there is nothing to analyse.':
    'この期間に完了したモバイルの計測がないため、分析できません。',
  'No desktop check finished in this window, so there is nothing to analyse.':
    'この期間に完了したデスクトップの計測がないため、分析できません。',
  'The rows in this window have no stored audit summaries, so the score cannot be split into the metrics behind it.':
    'この期間の計測には監査の要約が保存されていないため、スコアを指標ごとに分けられません。',
  'No reason was recorded.': '理由は記録されていません。',
  'The page did not paint any content.': 'ページに何も描画されませんでした。',
  'The page never painted its main content.': 'ページのメインコンテンツが描画されませんでした。',
  'The browser crashed while loading the page.':
    'ページの読み込み中にブラウザがクラッシュしました。',
  'The page stopped responding.': 'ページが応答しなくなりました。',
  'The page could not be loaded at all.': 'ページをまったく読み込めませんでした。',
  'The request for the page failed.': 'ページのリクエストが失敗しました。',
  'The domain could not be found.': 'ドメインが見つかりませんでした。',
  'The address was not a valid URL.': 'URL が正しくありませんでした。',
  'The page took too long to load and was given up on.':
    'ページの読み込みに時間がかかりすぎたため、中断しました。',
  'PageSpeed Insights refused the request — too many in a short time.':
    'PageSpeed Insights がリクエストを拒否しました — 短時間にリクエストが多すぎます。',
  'PageSpeed Insights returned a server error.':
    'PageSpeed Insights がサーバーエラーを返しました。',
  'PageSpeed Insights rejected the request.':
    'PageSpeed Insights がリクエストを受け付けませんでした。',
  'The widget opened a page the sample does not measure, usually because the hotel had no rooms for the dates searched.':
    'ウィジェットが計測対象外のページを表示しました。多くの場合、検索した日程にホテルの空室がなかったためです。',
  // The Hotel site view (decision 0037).
  Direct: 'ダイレクト',
  'Hotel site': 'ホテル公式サイト',
  'Where the hotels were measured': 'ホテルの計測場所',
  'Scripts by owner': '提供元別のスクリプト',
  'No hotel site was measured in this window.': 'この期間にホテル公式サイトの計測はありません。',
  'Booking Widget': '予約ウィジェット',
  'Recommender Widget': 'レコメンドウィジェット',
  'SearchBar Widget': '検索バーウィジェット',
  'Tripla tags': 'triplaのタグ',
  'Script bytes by owner, on the hotel’s page': 'ホテルのページ上の提供元別スクリプト容量',
  "Hotel's own": 'ホテル独自',
}
